import React from "react";
import { useDemo } from "../context/DemoContext";

// The ONLY call to action across the entire site.
export const BookDemoButton = ({ className = "", size = "md", testId = "book-demo-button" }) => {
  const { openDemo } = useDemo();
  const sizes = {
    sm: "px-5 py-2 text-[13px]",
    md: "px-7 py-3 text-sm",
    lg: "px-10 py-4 text-base",
  };
  return (
    <button
      data-testid={testId}
      onClick={openDemo}
      className={`mo-cta inline-flex items-center justify-center rounded-full bg-[#EA6A43] font-body font-medium tracking-wide text-white ${sizes[size]} ${className}`}
    >
      Book a Demo
    </button>
  );
};
